import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import ReplaceableText from '../../../../utils/text/ReplaceableText/index';

const Checklist = ({ rendering, fields }) => {
  return (
    <div className="vds-checklist vds-checklist--simple">
      <div className="vds-checklist__inner">
        <div className="vds-checklist__content">
          {fields?.title?.value && <ReplaceableText tag="strong" field={fields.title} />}
          <ul className="vds-checklist__list">
            <Placeholder name="checklist-items" rendering={rendering} />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Checklist;
